import React, { useEffect } from 'react'
import useCurrentUserId from '../../hooks/useCurrentUserId'
import { BookingListItemProps } from './booking_list_item'
import { usePaginatedList } from '../../hooks/usePaginatedList'
import { BookingStatus, IBooking } from '../../apilibrary/types/booking'
import { StudioService, UserService } from '../../apilibrary'
import BookingList from './booking_list'
import Box from '../../components/box'
import Button from '../../components/button'
import Typography from '../../components/typography'

const BookingHostedByMeList: React.FC = () => {
  const userId = useCurrentUserId() as string
  const [bookingsImHostingListItemProps, setBookingsImHostingListItemProps] = React.useState<BookingListItemProps[]>([])
  const {
    items: bookingsImHosting,
    setItems: setBookingsImHosting,
    hasMore: hasMoreBookingsImHosting,
    loading: loadingFetchBookingsImHosting,
    fetchNextPage: fetchNextPageBookingsImHosting
  } = usePaginatedList<IBooking>({
    fetchFunction: async (pagination) => {
      console.log('running this')
      const response = await UserService.getHostedBookingByUserId(userId, pagination)
      console.log(response)
      return response
    }
  })

  useEffect(() => {
    const handleResquestBookingResponse = async (bookingId: string, accept: boolean): Promise<void> => {
      await StudioService.respondToBookingRequest(bookingId, accept)
      const updatedItems = bookingsImHosting.map((booking) => {
        if (booking.id === bookingId) {
          return {
            ...booking,
            status: accept ? BookingStatus.PENDING_PAYMENT : BookingStatus.CANCELLED
          }
        }
        return booking
      })
      setBookingsImHosting(updatedItems)
    }

    const transformBookings = async (): Promise<void> => {
      const newListItems = await Promise.all(bookingsImHosting.map(async (booking) => {
        const coverImageUrl = await booking.studio.coverPicture.getPublicUrl()
        return {
          studioId: booking.studio.id,
          studioName: booking.studio.title,
          studioImageUrl: coverImageUrl,
          handleRequestBookingResponse: async (accept: boolean) => { await handleResquestBookingResponse(booking.id, accept); },
          isProvider: true,
          providedBy: `${booking.host.firstName ?? 'Unnamed'} ${booking.host.lastName ?? 'User'}`,
          serviceStartTime: booking.startTime,
          serviceEndTime: booking.endTime,
          status: booking.status
        }
      }))
      setBookingsImHostingListItemProps(newListItems)
    }

    void transformBookings()
  }, [bookingsImHosting, setBookingsImHosting])

  return (
    <Box>
      {!loadingFetchBookingsImHosting && bookingsImHosting.length === 0 && (
        <Typography color={'secondary'} mt={4} textAlign={'center'} fontSize={'1.5rem'} fontWeight={'bold'}>
          You have no bookings yet.
        </Typography>
      )}
      <BookingList bookings={bookingsImHostingListItemProps} />
      { hasMoreBookingsImHosting && (
        <Button disabled={loadingFetchBookingsImHosting} sx={{
          display: 'block',
          ml: 'auto'
        }} color='secondary' variant='outlined' onClick={fetchNextPageBookingsImHosting}>Load More</Button>
      )}
    </Box>
  )
}

export default BookingHostedByMeList
